import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const FeaturedInstitutesSection = ({ institutes, onBoothClick }) => {
  if (!institutes?.length) return null;

  return (
    <div className="mb-10">
      <div className="flex items-center gap-3 mb-5">
        <div className="flex items-center gap-2 bg-yellow-50 border border-yellow-200 px-4 py-2 rounded-full">
          <Icon name="Star" size={18} color="#d97706" />
          <span className="text-sm font-bold text-yellow-700 uppercase tracking-wide">Featured Institutes</span>
        </div>
        <span className="text-sm text-muted-foreground">Curated by StudyExpo</span>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {institutes?.map((institute) => (
          <div
            key={institute?.id}
            className="group relative bg-white rounded-xl shadow-md overflow-hidden cursor-pointer hover:shadow-xl transition-all duration-300 border-2 border-yellow-200 hover:border-yellow-400"
            onClick={() => onBoothClick?.(institute?.id)}
          >
            {/* Featured badge */}
            <div className="absolute top-3 left-3 z-10 bg-yellow-500 text-yellow-900 px-2.5 py-1 rounded-full text-xs font-bold flex items-center gap-1 shadow">
              <Icon name="Star" size={11} color="currentColor" />
              FEATURED
            </div>

            {institute?.ranking && (
              <div className="absolute top-3 right-3 z-10 bg-white/90 text-gray-700 px-2 py-1 rounded-full text-xs font-semibold shadow">
                #{institute?.ranking} Ranked
              </div>
            )}

            <div className="relative h-36 overflow-hidden">
              <img
                src={institute?.bannerUrl || 'https://img.rocket.new/generatedImages/rocket_gen_img_1f477cd97-1768735565694.png'}
                alt={`${institute?.instituteName || 'Institute'} campus`}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
              <div className="absolute bottom-2 left-2">
                <div className="w-12 h-12 bg-white rounded-lg p-1.5 shadow-lg">
                  <img
                    src={institute?.logoUrl || 'https://img.rocket.new/generatedImages/rocket_gen_img_1e7bb1524-1766485632262.png'}
                    alt={`${institute?.instituteName || 'Institute'} logo`}
                    className="w-full h-full object-contain"
                  />
                </div>
              </div>
            </div>

            <div className="p-3">
              <h3 className="text-sm font-bold text-foreground mb-1.5 line-clamp-2 group-hover:text-primary transition-colors">
                {institute?.instituteName}
              </h3>

              {institute?.state && (
                <div className="flex items-center gap-1 text-xs text-muted-foreground mb-2">
                  <Icon name="MapPin" size={11} color="var(--color-muted-foreground)" />
                  <span>{institute?.state}</span>
                </div>
              )}

              {institute?.categories?.length > 0 && (
                <div className="flex flex-wrap gap-1 mb-2">
                  {institute?.categories?.slice(0, 2)?.map((cat) => (
                    <span key={cat} className="px-1.5 py-0.5 rounded-full text-xs bg-yellow-50 text-yellow-700 border border-yellow-200">
                      {cat}
                    </span>
                  ))}
                  {institute?.categories?.length > 2 && (
                    <span className="px-1.5 py-0.5 rounded-full text-xs bg-muted text-muted-foreground">
                      +{institute?.categories?.length - 2}
                    </span>
                  )}
                </div>
              )}

              <Button
                variant="ghost"
                size="sm"
                iconName="ArrowRight"
                iconPosition="right"
                className="w-full text-primary hover:bg-primary/10 text-xs mt-1"
              >
                Visit Booth
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FeaturedInstitutesSection;
